'use client';

import { useEffect } from 'react';

import { useAdminViewerBar } from './AdminViewerBarContext';

export default function AdminPageMeta({ editHref }) {
  const { setEditHref } = useAdminViewerBar();

  useEffect(() => {
    const next = typeof editHref === 'string' ? editHref : '';
    setEditHref(next);
    return () => setEditHref('');
  }, [editHref, setEditHref]);

  return null;
}
